module.exports = __webpack_public_path__ + "static/media/no-drivers-added.d047dc4e.svg";